import { useEffect } from 'react';
import { Outlet } from 'react-router';

// material-ui
import { Theme, useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// trendio-selfcare-ui-kit
import {
  handlerDrawerOpen,
  useGetMenuMaster,
  MenuOrientation,
  Footer,
  Loader,
  useConfig,
  CustomAppBar as HorizontalBar
} from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import Navigation from './Drawer/DrawerContent/Navigation';
import Drawer from './Drawer';
import Header from './Header';

import AuthGuard from 'routes/guards/AuthGuard';

import MerchantAlertsHeader from 'features/permissions/components/MerchantAlertsHeader';

import AppVersionChecker from 'layout/Dashboard/AppVersionChecker';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const matchDownXL = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'));
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const { container, miniDrawer, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;
  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!matchDownXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL]);

  if (menuMasterLoading) return <Loader />;
  return (
    <AuthGuard>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <AppVersionChecker />
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar navigation={<Navigation />} />}
        <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
          <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              ...(container && { px: { xs: 0, sm: 2 } }),
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '16px'
            }}
          >
            <MerchantAlertsHeader />
            <Outlet />
            <Footer />
          </Container>
        </Box>
      </Box>
    </AuthGuard>
  );
}
